module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/goodreads-white-86b1b159bcfc7382157917e444b13d26.svg";